<template>
  <div class="single-choice-field">
    <label for="single-choice">Option<lang-toggler :lang="text.lang" @input="text.lang = $event" @applyAll="onApplyToAllLangs($event)"/></label>
    <div v-if="singleChoiceHasImage" class="icon-button file-btn">
      <ImageCropper :target-width='500' :target-height='500' :isModal='true' @inputImage='updateImage' @deleteImage='deleteImage' :value="imageSrc">
        <div class="image-cropper">
          <i class="material-icons">add_photo_alternate</i>
        </div>
      </ImageCropper>
    </div>
    <textarea v-if="!singleChoiceHasImage" :id="id" v-model="text[text.lang]" v-on:blur="updateLang('text', text.lang, $event.target.value)"></textarea>
    <input v-if="singleChoiceHasImage" class="action-input" type="text" :id="id" v-model="text[text.lang]" v-on:blur="updateLang('text', text.lang, $event.target.value)"></input>
    <div class="single-choice-field-controls">
      <a class="icon-button" href="#" v-on:click.prevent="del">
        <i class="material-icons">close</i>
      </a>
    </div>
      <!-- on single-choice jump to -->
    <div class="target-time-wrapper">
        <label for="target-time">if clicked do</label>
        <choose-behaviour v-on:pick="storeMetaData" :modelItem="behaviour" />
    </div>
    <div class="feedback-wrapper">
      <label for="feedback">Feedback<lang-toggler :lang="feedback.lang" @input="feedback.lang = $event" @applyAll="onApplyFeedbackToAllLangs($event)"/></label>
      <input type="text" name="feedback" class="feedback" v-model="feedback[feedback.lang]" v-on:blur="updateLang('feedback', feedback.lang, $event.target.value)" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import ChooseBehaviour from "./chooseBehaviour";
import ImageCropper from "./imageCropper";
import LangToggler from "./langToggler";
import { multiLangTextObject } from "./../../utils/multiLang";

export default {
  name: "singleChoiceField",

  props: ["id", "option", "singleChoiceId", "singleChoiceHasImage"],

  components: {
    ChooseBehaviour,
    ImageCropper: ImageCropper,
    LangToggler
  },

  created() {
    const option = this.option || {};
    this.init(option);
  },

  watch: {
    option: "onOptionChanged"
  },

  data() {
    return {
      text: null,
      image: null,
      correct: null,
      jumpTo: null,
      feedback: null,
      behaviour: {}
    };
  },

  computed: {
    ...mapGetters(['currentTime', 'selectedAsset']),
    imageSrc: function() {
      let imageSrc = null
      if (typeof this.image === 'string') {
        imageSrc = this.image
      } else if (this.image) {
        imageSrc = this.image[this.text.lang]
      }
      return imageSrc && imageSrc !== '' ? imageSrc : null
    }
  },

  methods: {
    ...mapActions(['storeImage', 'deleteImageFromStore']),
    init(option) {
      this.text = multiLangTextObject(option.text);
      this.image = option.image;
      this.correct = option.correct;
      this.jumpTo = option.jumpTo;
      this.feedback = multiLangTextObject(option.feedback);
      this.behaviour = option.behaviour || {
        value: {}
      };
    },
    update(key, value) {
      console.log("update", key, value)
      this[key] = value;
      const { text, image, correct, jumpTo, feedback, behaviour } = this;
      this.$emit("update", {
        text,
        image,
        correct,
        jumpTo,
        feedback,
        behaviour
      });
    },
    updateLang(key, lang, value) {
      console.log("updateLang", key, lang, value)
      this[key][lang] = value;
      this.update(key, this[key]);
    },
    onApplyToAllLangs: function(ev) {
      let textVal = this.text[ev]
      let imageVal = this.image ? this.image[ev] : this.image
      for (const k in this.text) {
        if (k !== 'lang') {
          this.text[k] = textVal
          if (this.image && this.image[k]) {
            this.image[k] = imageVal
          }
        }
      }
    },
    onApplyFeedbackToAllLangs: function(ev) {
      let textVal = this.feedback[ev]
      for (const k in this.feedback) {
        if (k !== 'lang') {
          this.feedback[k] = textVal
        }
      }
    },
    updateImage(event) {
      const asset = this.selectedAsset
      this.image = this.image ? this.image : { lang: this.text.lang }
      const imageToStore = {name: `${this.text.lang || 'DE'}-${asset.id}-${this.singleChoiceId}_${this.id}`, base64: event}
      this.storeImage(imageToStore).then((imageUrl) => {
        this.$set(this.image, this.text.lang, imageUrl)
        this.update('image', this.image);
      });
    },
    del() {
      this.$emit("delete");
    },
    deleteImage() {
      this.deleteImageFromStore({imageUrl: this.image}).then((imageUrl) => {
        this.image[this.text.lang] = ''
        this.update('image', this.image);
      });
    },
    storeMetaData(val) {
      console.log("store behaviour meta data", val);
      this.behaviour.value = val;
    },
    onOptionChanged(newVal) {
      console.log("onOptionChanged", newVal);
      this.init(newVal);
    }
  }
};
</script>
